// extracted by mini-css-extract-plugin
module.exports = {"heading":"heading_heading__az_04","centered":"heading_centered__FgZep","sm":"heading_sm__PkYTD","lg":"heading_lg__I_Urf"};